import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        {/* Error Code */}
        <div className="space-y-4">
          <h1 className="text-9xl font-bold text-indigo-600 opacity-80">
            404
          </h1>
          <h2 className="text-3xl font-semibold text-gray-900 sm:text-4xl">
            Page introuvable
          </h2>
          <p className="text-lg text-gray-600 max-w-sm mx-auto">
            La page que vous recherchez n'existe pas ou a été déplacée.
          </p>
        </div>

        {/* Illustration */}
        <div className="relative">
          <div className="w-32 h-32 mx-auto bg-indigo-100 rounded-full flex items-center justify-center">
            <Search className="w-16 h-16 text-indigo-500" />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
            >
              <Home className="w-5 h-5 mr-2" />
              Retour à l'accueil
            </Link>
            
            <button
              onClick={() => navigate(-1)}
              className="inline-flex items-center justify-center px-6 py-3 border border-gray-300 text-base font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Page précédente
            </button>
          </div>

          {/* Quick Links */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-4">Pages populaires :</p>
            <div className="flex flex-wrap gap-2 justify-center">
              <Link
                to="/property-search-listings"
                className="text-sm px-3 py-1 bg-white rounded-full text-indigo-600 hover:text-indigo-800 hover:bg-indigo-50 transition-colors duration-200 border border-indigo-200"
              >
                Propriétés
              </Link>
              <Link
                to="/commune-explorer"
                className="text-sm px-3 py-1 bg-white rounded-full text-indigo-600 hover:text-indigo-800 hover:bg-indigo-50 transition-colors duration-200 border border-indigo-200"
              >
                Communes
              </Link>
              <Link
                to="/legal-services-center"
                className="text-sm px-3 py-1 bg-white rounded-full text-indigo-600 hover:text-indigo-800 hover:bg-indigo-50 transition-colors duration-200 border border-indigo-200"
              >
                Services
              </Link>
              <Link
                to="/roi-calculator-tool"
                className="text-sm px-3 py-1 bg-white rounded-full text-indigo-600 hover:text-indigo-800 hover:bg-indigo-50 transition-colors duration-200 border border-indigo-200"
              >
                ROI Calculator
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;